import { render, staticRenderFns } from "./WishlistButton.vue?vue&type=template&id=11c6b5df&lang=pug&"
import script from "./WishlistButton.vue?vue&type=script&lang=ts&"
export * from "./WishlistButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports